// 6 languages × minimal string set for the simplified storefront.
// Keys are ENGLISH-friendly identifiers; values are translations.

export const LANGUAGES = [
    { id: "en", label: "English", flag: "🇬🇧" },
    { id: "sq", label: "Shqip", flag: "🇦🇱" },
    { id: "hi", label: "हिन्दी", flag: "🇮🇳" },
    { id: "it", label: "Italiano", flag: "🇮🇹" },
    { id: "el", label: "Ελληνικά", flag: "🇬🇷" },
    { id: "fr", label: "Français", flag: "🇫🇷" },
    { id: "mk", label: "Македонски", flag: "🇲🇰" },
];

export const translations = {
    sq: {
        ui_language: "Gjuha",
        ui_currency: "Monedha",
        search_placeholder: "Kërko produkte…",
        promo_banner: "Transport falas për porositë mbi 2000 L · Pagesa në dorëzim e disponueshme",
        section_hot_deals: "Oferta të nxehta",
        section_all_products: "Të gjithë produktet",
        section_no_products: "Nuk u gjet asnjë produkt.",
        section_shop_by_category: "Bli sipas kategorisë",
        filter_all: "Të gjitha",
        "cat.produce": "Fruta & Perime",
        "cat.dairy": "Bulmet & Vezë",
        "cat.bakery": "Bukë",
        "cat.beverages": "Pije",
        "cat.meat": "Mish & Peshk",
        "cat.pantry": "Bazë",
        "cat.beauty": "Bukuria & Kujdesi personal",
        "cat.medicine": "Ilaçe & Farmaci",
        category_coming_soon: "Së shpejti",
        section_select_category: "Zgjidh një kategori për të shfletuar produkte",
        sub_filter_all: "Të gjitha",
        "parent.dairy_bread_eggs": "Bulmet, bukë & vezë",
        "parent.fruits_veg": "Fruta & perime",
        "parent.beverages": "Pije",
        "parent.snacks_munchies": "Snacks",
        "parent.breakfast_instant": "Mëngjes & ushqim i shpejtë",
        "parent.rtc": "RTC (Gati për t'u gatuar)",
        "parent.rte": "RTE (Gati për t'u ngrënë)",
        "parent.noodles_pasta": "Noodles & Pasta",
        "parent.mouth_freshners": "Freskues goje (Mukhwas)",
        "parent.pickles": "Turshi",
        "parent.spices_powder": "Erëza",
        "parent.spices_whole": "Erëza të plota",
        "parent.oil_ghee": "Vaj & Gji",
        "parent.puja_needs": "Nevoja për Puja",
        "parent.sweet_tooth": "Ëmbëlsira indiane (Mithai)",
        "parent.bakery_biscuits": "Furrë & biskota",
        "parent.tea_coffee": "Çaj, kafe & qumësht",
        "parent.atta_dal_rice": "Miell, bishtajore & oriz",
        "parent.masala_oils": "Erëza, vajra & më shumë",
        "parent.sauces_spreads": "Salca & krem llokumesh",
        "parent.meat_fish": "Mish, pulë & peshk",
        "parent.organic_healthy": "Organike & jetë e shëndetshme",
        "parent.baby_care": "Kujdesi për fëmijën",
        "parent.pharma_wellness": "Farmaci & shëndet",
        "parent.cleaning": "Pastrim shtëpie",
        "parent.home_office": "Shtëpi & zyrë",
        "parent.personal_care": "Kujdes personal",
        "parent.pet_care": "Kujdesi për kafshët",
        product_off: "ULJE",
        product_add: "Shto",
        product_out_of_stock: "Mbaruar",
        nav_login: "Hyr",
        nav_logout: "Dil",
        nav_my_profile: "Profili im",
        account_title: "Profili im",
        account_profile: "Të dhënat e mia",
        account_phone: "Telefoni",
        account_name: "Emri",
        account_name_empty: "Shto emrin tënd",
        account_name_saved: "Emri u ruajt",
        account_orders: "Porositë e mia",
        account_no_orders: "Ende nuk ke porosi.",
        account_start_shopping: "Fillo blerjet",
        account_items: "Produktet",
        account_back_to_shop: "Kthehu te dyqani",
        order_status_placed: "E pranuar",
        order_status_confirmed: "E konfirmuar",
        order_status_out_for_delivery: "Në dorëzim",
        order_status_delivered: "E dorëzuar",
        order_status_cancelled: "E anuluar",
        cart_title: "Shporta",
        cart_empty: "Shporta jote është bosh",
        cart_empty_hint: "Shto produkte për të vazhduar.",
        cart_subtotal: "Nëntotali",
        cart_checkout: "Përfundo blerjen",
        cart_continue: "Vazhdo blerjet",
        login_title: "Hyr ose krijo llogari",
        login_subtitle: "Vendos numrin e telefonit për të vazhduar.",
        login_phone_label: "Numri i telefonit",
        login_phone_placeholder: "+355 68 123 4567",
        login_continue: "Vazhdo",
        login_send_otp: "Dërgo kodin",
        login_sending: "Po dërgon…",
        login_otp_title: "Verifiko telefonin",
        login_otp_register_title: "Krijo llogarinë",
        login_otp_reset_title: "Rivendos fjalëkalimin",
        login_otp_subtitle: "Të dërguam një kod një-përdorimësh në",
        login_otp_register_subtitle: "I ri këtu — të dërguam një kod për të verifikuar",
        login_otp_reset_subtitle: "Të dërguam një kod rivendosjeje në",
        login_verify: "Verifiko",
        login_verifying: "Po verifikon…",
        login_resend: "Ridërgo kodin",
        login_change_number: "Ndrysho numrin",
        login_dev_hint: "Modaliteti i provës: kodi është",
        login_password_label: "Fjalëkalimi",
        login_password_placeholder: "Të paktën 6 karaktere",
        login_password_signin_title: "Mirëse u ktheve",
        login_password_signin_subtitle: "Vendos fjalëkalimin për të hyrë në",
        login_signin_btn: "Hyr",
        login_signing_in: "Po hyn…",
        login_forgot_password: "Harrove fjalëkalimin?",
        login_set_password_title: "Krijo fjalëkalimin tënd",
        login_set_password_subtitle: "Përdore për të hyrë herën tjetër — pa OTP.",
        login_name_label: "Emri (opsionale)",
        login_create_account_btn: "Krijo llogarinë",
        login_creating: "Po krijon…",
        login_reset_title: "Vendos fjalëkalim të ri",
        login_reset_btn: "Përditëso fjalëkalimin",
        login_back: "Mbrapa",
        login_legacy_needs_setup: "Të lutem cakto një fjalëkalim. Trokit \"Harrove fjalëkalimin?\" për të marrë OTP.",
        checkout_title: "Përfundo porosinë",
        checkout_name_label: "Emri yt",
        checkout_address_label: "Adresa e dërgesës",
        checkout_address_placeholder: "Rruga, qyteti, kodi postar",
        checkout_notes_label: "Shënime (opsionale)",
        checkout_alt_phone_label: "Numri i WhatsApp (opsionale)",
        checkout_alt_phone_placeholder: "p.sh., 68 999 1234",
        checkout_country_label: "Shteti",
        checkout_total: "Totali",
        checkout_subtotal: "Nëntotali",
        checkout_shipping: "Dorëzimi",
        checkout_place: "Vendos porosinë",
        checkout_placing: "Po vendos…",
        checkout_success_title: "Porosia u vendos!",
        checkout_success_subtitle: "Do ta marrësh brenda 30 minutash. Numri i porosisë:",
        checkout_continue: "Vazhdo blerjet",
        checkout_payment_method_label: "Mënyra e pagesës",
        payment_method_cod: "Pagesa në dorëzim",
        payment_method_cod_hint: "Paguaj kur të mbërrijë porosia",
        payment_method_card: "Pagesa me kartë",
        payment_method_card_hint: "Kreditore ose debitore",
        payment_method_card_paid: "Paguar me kartë",
        payment_method_coming_soon: "Së shpejti",
        payment_method_card_coming_soon: "Pagesa me kartë vjen së shpejti. Tani përdor pagesën në dorëzim.",
        checkout_pay_with_card: "Paguaj me kartë",
        checkout_card_redirect_hint: "Do të të çojmë tek faqja e sigurt e Stripe-it për të paguar.",
        checkout_verifying_payment: "Po verifikojmë pagesën…",
        checkout_verifying_payment_hint: "Mos e mbyll dritaren — porosia po krijohet.",
        checkout_payment_cancelled: "Pagesa u anulua. Provo përsëri.",
        checkout_payment_expired: "Pagesa skadoi. Provo përsëri.",
        checkout_payment_timeout: "Pagesa nuk u verifikua dot. Kontrollo porositë e mia.",
        footer_made_in: "I bërë me ♥ në Shqipëri",
        toast_added: "U shtua",
        toast_removed: "U hoq",
        toast_otp_sent: "Kodi u dërgua",
        toast_otp_error: "Kod i pasaktë. Provo përsëri.",
        toast_otp_send_error: "Nuk u arrit të dërgohej. Provo përsëri.",
        toast_login_success: "Mirëserdhe!",
        toast_logged_out: "Dole jashtë.",
        toast_order_error: "Porosia dështoi. Provo përsëri.",
        toast_login_required: "Identifikohu për të vazhduar.",
    },
    en: {
        ui_language: "Language",
        ui_currency: "Currency",
        search_placeholder: "Search products…",
        promo_banner: "Free shipping on orders over 2000 L · Cash on delivery available",
        section_hot_deals: "Hot deals",
        section_all_products: "All products",
        section_no_products: "No products found.",
        section_shop_by_category: "Shop by category",
        filter_all: "All",
        "cat.produce": "Fruits & Veg",
        "cat.dairy": "Dairy & Eggs",
        "cat.bakery": "Bakery",
        "cat.beverages": "Beverages",
        "cat.meat": "Meat & Fish",
        "cat.pantry": "Pantry",
        "cat.beauty": "Beauty & Personal Care",
        "cat.medicine": "Medicines & Pharmacy",
        category_coming_soon: "Coming soon",
        section_select_category: "Select a category to browse products",
        sub_filter_all: "All",
        "parent.dairy_bread_eggs": "Dairy, bread & eggs",
        "parent.fruits_veg": "Fruits & vegetables",
        "parent.beverages": "Beverages",
        "parent.snacks_munchies": "Snacks",
        "parent.breakfast_instant": "Breakfast & instant food",
        "parent.rtc": "RTC (Ready To Cook)",
        "parent.rte": "RTE (Ready To Eat)",
        "parent.noodles_pasta": "Noodles & Pasta",
        "parent.mouth_freshners": "Mouth Freshners (Mukhwas)",
        "parent.pickles": "Pickles",
        "parent.spices_powder": "Spices",
        "parent.spices_whole": "Whole Spices",
        "parent.oil_ghee": "Oil & Ghee",
        "parent.puja_needs": "Puja Needs",
        "parent.sweet_tooth": "Indian Sweets (Mithai)",
        "parent.bakery_biscuits": "Bakery & biscuits",
        "parent.tea_coffee": "Tea, coffee & milk drinks",
        "parent.atta_dal_rice": "Atta, dal & rice",
        "parent.masala_oils": "Masala, oils & more",
        "parent.sauces_spreads": "Sauces & spreads",
        "parent.meat_fish": "Chicken, meat & fish",
        "parent.organic_healthy": "Organic & healthy living",
        "parent.baby_care": "Baby care",
        "parent.pharma_wellness": "Pharma & wellness",
        "parent.cleaning": "Cleaning essentials",
        "parent.home_office": "Home & office",
        "parent.personal_care": "Personal care",
        "parent.pet_care": "Pet care",
        product_off: "OFF",
        product_add: "Add",
        product_out_of_stock: "Out of stock",
        nav_login: "Sign in",
        nav_logout: "Sign out",
        nav_my_profile: "My profile",
        account_title: "My profile",
        account_profile: "Profile",
        account_phone: "Phone",
        account_name: "Name",
        account_name_empty: "Add your name",
        account_name_saved: "Name saved",
        account_orders: "My orders",
        account_no_orders: "You don't have any orders yet.",
        account_start_shopping: "Start shopping",
        account_items: "Items",
        account_back_to_shop: "Back to shop",
        order_status_placed: "Placed",
        order_status_confirmed: "Confirmed",
        order_status_out_for_delivery: "Out for delivery",
        order_status_delivered: "Delivered",
        order_status_cancelled: "Cancelled",
        cart_title: "Your cart",
        cart_empty: "Your cart is empty",
        cart_empty_hint: "Add products to continue.",
        cart_subtotal: "Subtotal",
        cart_checkout: "Checkout",
        cart_continue: "Continue shopping",
        login_title: "Sign in or create account",
        login_subtitle: "Enter your mobile number to continue.",
        login_phone_label: "Mobile number",
        login_phone_placeholder: "+355 68 123 4567",
        login_continue: "Continue",
        login_send_otp: "Send code",
        login_sending: "Sending…",
        login_otp_title: "Verify your phone",
        login_otp_register_title: "Create your account",
        login_otp_reset_title: "Reset your password",
        login_otp_subtitle: "We've sent a one-time code to",
        login_otp_register_subtitle: "New here — we've sent a one-time code to",
        login_otp_reset_subtitle: "We've sent a one-time reset code to",
        login_verify: "Verify",
        login_verifying: "Verifying…",
        login_resend: "Resend code",
        login_change_number: "Change number",
        login_dev_hint: "Dev mode: your code is",
        login_password_label: "Password",
        login_password_placeholder: "At least 6 characters",
        login_password_signin_title: "Welcome back",
        login_password_signin_subtitle: "Enter your password to sign in to",
        login_signin_btn: "Sign in",
        login_signing_in: "Signing in…",
        login_forgot_password: "Forgot password?",
        login_set_password_title: "Create your password",
        login_set_password_subtitle: "Use it next time — no OTP needed.",
        login_name_label: "Name (optional)",
        login_create_account_btn: "Create account",
        login_creating: "Creating…",
        login_reset_title: "Set a new password",
        login_reset_btn: "Update password",
        login_back: "Back",
        login_legacy_needs_setup: "Please set a password. Tap \"Forgot password?\" to receive an OTP.",
        checkout_title: "Complete your order",
        checkout_name_label: "Your name",
        checkout_address_label: "Delivery address",
        checkout_address_placeholder: "Street, city, postal code",
        checkout_notes_label: "Notes (optional)",
        checkout_alt_phone_label: "WhatsApp number (optional)",
        checkout_alt_phone_placeholder: "e.g., 68 999 1234",
        checkout_country_label: "Country",
        checkout_total: "Total",
        checkout_subtotal: "Subtotal",
        checkout_shipping: "Shipping",
        checkout_place: "Place order",
        checkout_placing: "Placing…",
        checkout_success_title: "Order placed!",
        checkout_success_subtitle: "You'll receive it within 30 minutes. Order ID:",
        checkout_continue: "Continue shopping",
        checkout_payment_method_label: "Payment method",
        payment_method_cod: "Cash on delivery",
        payment_method_cod_hint: "Pay when your order arrives",
        payment_method_card: "Pay with card",
        payment_method_card_hint: "Credit or debit card",
        payment_method_card_paid: "Paid by card",
        payment_method_coming_soon: "Coming soon",
        payment_method_card_coming_soon: "Card payments coming soon. Please use Cash on Delivery for now.",
        checkout_pay_with_card: "Continue to payment",
        checkout_card_redirect_hint: "You'll be redirected to Stripe's secure checkout to complete payment.",
        checkout_verifying_payment: "Verifying your payment…",
        checkout_verifying_payment_hint: "Don't close this window — we're creating your order.",
        checkout_payment_cancelled: "Payment was cancelled. Please try again.",
        checkout_payment_expired: "The payment session expired. Please try again.",
        checkout_payment_timeout: "Couldn't verify the payment in time. Check your orders.",
        footer_made_in: "Made with ♥ in Albania",
        toast_added: "Added",
        toast_removed: "Removed",
        toast_otp_sent: "Code sent",
        toast_otp_error: "Wrong code. Try again.",
        toast_otp_send_error: "Could not send. Try again.",
        toast_login_success: "Welcome back!",
        toast_logged_out: "Signed out.",
        toast_order_error: "Order failed. Try again.",
        toast_login_required: "Please sign in to continue.",
    },
    hi: {
        ui_language: "भाषा",
        ui_currency: "मुद्रा",
        search_placeholder: "उत्पाद खोजें…",
        promo_banner: "2000 L से अधिक के ऑर्डर पर मुफ्त शिपिंग · कैश ऑन डिलीवरी उपलब्ध",
        section_hot_deals: "हॉट डील्स",
        section_all_products: "सभी उत्पाद",
        section_no_products: "कोई उत्पाद नहीं मिला।",
        section_shop_by_category: "श्रेणी से खरीदें",
        filter_all: "सभी",
        "cat.produce": "फल और सब्ज़ी",
        "cat.dairy": "डेयरी और अंडे",
        "cat.bakery": "बेकरी",
        "cat.beverages": "पेय",
        "cat.meat": "मांस और मछली",
        "cat.pantry": "पैन्ट्री",
        "cat.beauty": "सौंदर्य और स्वयं देखभाल",
        "cat.medicine": "दवाइयाँ और फार्मेसी",
        product_off: "छूट",
        product_add: "जोड़ें",
        product_out_of_stock: "स्टॉक में नहीं",
        nav_login: "लॉगिन",
        nav_logout: "लॉग आउट",
        nav_my_profile: "मेरी प्रोफ़ाइल",
        account_title: "मेरी प्रोफ़ाइल",
        account_profile: "प्रोफ़ाइल",
        account_phone: "फ़ोन",
        account_name: "नाम",
        account_name_empty: "अपना नाम जोड़ें",
        account_name_saved: "नाम सहेजा गया",
        account_orders: "मेरे ऑर्डर",
        account_no_orders: "अभी तक कोई ऑर्डर नहीं है।",
        account_start_shopping: "खरीदारी शुरू करें",
        account_items: "वस्तुएँ",
        account_back_to_shop: "दुकान पर वापस जाएँ",
        order_status_placed: "ऑर्डर किया गया",
        order_status_confirmed: "पुष्टि की गई",
        order_status_out_for_delivery: "डिलीवरी के लिए निकला",
        order_status_delivered: "डिलीवर हो गया",
        order_status_cancelled: "रद्द कर दिया गया",
        cart_title: "आपकी कार्ट",
        cart_empty: "आपकी कार्ट खाली है",
        cart_empty_hint: "जारी रखने के लिए उत्पाद जोड़ें।",
        cart_subtotal: "उप-योग",
        cart_checkout: "चेकआउट",
        cart_continue: "खरीदारी जारी रखें",
        login_title: "लॉगिन करें या खाता बनाएँ",
        login_subtitle: "जारी रखने के लिए अपना मोबाइल नंबर डालें।",
        login_phone_label: "मोबाइल नंबर",
        login_phone_placeholder: "+91 98765 43210",
        login_continue: "जारी रखें",
        login_send_otp: "कोड भेजें",
        login_sending: "भेजा जा रहा है…",
        login_otp_title: "अपना फ़ोन सत्यापित करें",
        login_otp_register_title: "अपना खाता बनाएँ",
        login_otp_reset_title: "अपना पासवर्ड रीसेट करें",
        login_otp_subtitle: "हमने एक OTP भेजा है",
        login_otp_register_subtitle: "नए उपयोगकर्ता — सत्यापन के लिए OTP भेजा है",
        login_otp_reset_subtitle: "हमने रीसेट कोड भेजा है",
        login_verify: "सत्यापित करें",
        login_verifying: "सत्यापित किया जा रहा है…",
        login_resend: "कोड फिर से भेजें",
        login_change_number: "नंबर बदलें",
        login_dev_hint: "टेस्ट मोड: आपका कोड है",
        login_password_label: "पासवर्ड",
        login_password_placeholder: "कम से कम 6 अक्षर",
        login_password_signin_title: "वापसी पर स्वागत है",
        login_password_signin_subtitle: "लॉगिन के लिए पासवर्ड डालें —",
        login_signin_btn: "लॉगिन",
        login_signing_in: "लॉगिन हो रहा है…",
        login_forgot_password: "पासवर्ड भूल गए?",
        login_set_password_title: "अपना पासवर्ड बनाएँ",
        login_set_password_subtitle: "अगली बार इसी से लॉगिन करें — OTP की ज़रूरत नहीं।",
        login_name_label: "नाम (वैकल्पिक)",
        login_create_account_btn: "खाता बनाएँ",
        login_creating: "बनाया जा रहा है…",
        login_reset_title: "नया पासवर्ड सेट करें",
        login_reset_btn: "पासवर्ड अपडेट करें",
        login_back: "वापस",
        login_legacy_needs_setup: "कृपया पासवर्ड सेट करें। OTP प्राप्त करने के लिए \"पासवर्ड भूल गए?\" पर टैप करें।",
        checkout_title: "अपना ऑर्डर पूरा करें",
        checkout_name_label: "आपका नाम",
        checkout_address_label: "डिलीवरी का पता",
        checkout_address_placeholder: "सड़क, शहर, पिन कोड",
        checkout_notes_label: "नोट्स (वैकल्पिक)",
        checkout_alt_phone_label: "व्हाट्सऐप नंबर (वैकल्पिक)",
        checkout_alt_phone_placeholder: "उदा., 68 999 1234",
        checkout_country_label: "देश",
        checkout_total: "कुल",
        checkout_subtotal: "उप-योग",
        checkout_shipping: "शिपिंग",
        checkout_place: "ऑर्डर करें",
        checkout_placing: "ऑर्डर हो रहा है…",
        checkout_success_title: "ऑर्डर सफल!",
        checkout_success_subtitle: "आप इसे 30 मिनट में प्राप्त करेंगे। ऑर्डर ID:",
        checkout_continue: "खरीदारी जारी रखें",
        checkout_payment_method_label: "भुगतान का तरीका",
        payment_method_cod: "कैश ऑन डिलीवरी",
        payment_method_cod_hint: "जब ऑर्डर पहुँचे, भुगतान करें",
        payment_method_card: "कार्ड से भुगतान",
        payment_method_card_hint: "क्रेडिट या डेबिट कार्ड",
        payment_method_card_paid: "कार्ड से भुगतान किया",
        payment_method_coming_soon: "जल्द ही",
        payment_method_card_coming_soon: "कार्ड भुगतान जल्द ही उपलब्ध होगा। अभी कैश ऑन डिलीवरी का उपयोग करें।",
        checkout_pay_with_card: "भुगतान के लिए जारी रखें",
        checkout_card_redirect_hint: "भुगतान पूरा करने के लिए आपको Stripe के सुरक्षित पृष्ठ पर ले जाया जाएगा।",
        checkout_verifying_payment: "आपके भुगतान की पुष्टि की जा रही है…",
        checkout_verifying_payment_hint: "विंडो बंद न करें — आपका ऑर्डर बनाया जा रहा है।",
        checkout_payment_cancelled: "भुगतान रद्द कर दिया गया। कृपया फिर से प्रयास करें।",
        checkout_payment_expired: "भुगतान सत्र समाप्त हो गया। कृपया फिर से प्रयास करें।",
        checkout_payment_timeout: "भुगतान सत्यापित नहीं हो सका। अपने ऑर्डर देखें।",
        footer_made_in: "Albania में ♥ से बना",
        toast_added: "जोड़ा गया",
        toast_removed: "हटाया गया",
        toast_otp_sent: "कोड भेजा गया",
        toast_otp_error: "गलत कोड। फिर से प्रयास करें।",
        toast_otp_send_error: "भेजने में विफल। फिर से प्रयास करें।",
        toast_login_success: "स्वागत है!",
        toast_logged_out: "लॉग आउट हो गए।",
        toast_order_error: "ऑर्डर विफल। फिर से प्रयास करें।",
        toast_login_required: "जारी रखने के लिए लॉगिन करें।",
        category_coming_soon: "जल्द ही",
        section_select_category: "उत्पाद देखने के लिए श्रेणी चुनें",
        sub_filter_all: "सभी",
        "parent.dairy_bread_eggs": "डेयरी, ब्रेड और अंडे",
        "parent.fruits_veg": "फल और सब्ज़ी",
        "parent.beverages": "पेय",
        "parent.snacks_munchies": "स्नैक्स",
        "parent.breakfast_instant": "नाश्ता और इंस्टेंट फूड",
        "parent.rtc": "RTC (पकाने के लिए तैयार)",
        "parent.rte": "RTE (खाने के लिए तैयार)",
        "parent.noodles_pasta": "नूडल्स और पास्ता",
        "parent.mouth_freshners": "माउथ फ्रेशनर (मुखवास)",
        "parent.pickles": "अचार",
        "parent.spices_powder": "मसाले",
        "parent.spices_whole": "साबुत मसाले",
        "parent.oil_ghee": "तेल और घी",
        "parent.puja_needs": "पूजा सामग्री",
        "parent.sweet_tooth": "भारतीय मिठाई",
        "parent.bakery_biscuits": "बेकरी और बिस्किट",
        "parent.tea_coffee": "चाय, कॉफ़ी और दूध",
        "parent.atta_dal_rice": "आटा, दाल और चावल",
        "parent.masala_oils": "मसाले, तेल और अधिक",
        "parent.sauces_spreads": "सॉस और स्प्रेड",
        "parent.meat_fish": "चिकन, मटन और मछली",
        "parent.organic_healthy": "ऑर्गेनिक और स्वस्थ जीवन",
        "parent.baby_care": "शिशु देखभाल",
        "parent.pharma_wellness": "फार्मा और स्वास्थ्य",
        "parent.cleaning": "सफ़ाई आवश्यक",
        "parent.home_office": "घर और कार्यालय",
        "parent.personal_care": "व्यक्तिगत देखभाल",
        "parent.pet_care": "पालतू पशु देखभाल",
    },
    it: {
        ui_language: "Lingua",
        ui_currency: "Valuta",
        search_placeholder: "Cerca prodotti…",
        promo_banner: "Spedizione gratuita per ordini oltre 2000 L · Pagamento alla consegna disponibile",
        section_hot_deals: "Offerte calde",
        section_all_products: "Tutti i prodotti",
        section_no_products: "Nessun prodotto trovato.",
        section_shop_by_category: "Acquista per categoria",
        filter_all: "Tutti",
        "cat.produce": "Frutta e Verdura",
        "cat.dairy": "Latticini e Uova",
        "cat.bakery": "Panetteria",
        "cat.beverages": "Bevande",
        "cat.meat": "Carne e Pesce",
        "cat.pantry": "Dispensa",
        product_off: "SCONTO",
        product_add: "Aggiungi",
        product_out_of_stock: "Esaurito",
        nav_login: "Accedi",
        nav_logout: "Esci",
        cart_title: "Il tuo carrello",
        cart_empty: "Il carrello è vuoto",
        cart_empty_hint: "Aggiungi prodotti per continuare.",
        cart_subtotal: "Subtotale",
        cart_checkout: "Procedi all'acquisto",
        cart_continue: "Continua lo shopping",
        login_title: "Accedi con telefono",
        login_subtitle: "Ti invieremo un codice a 6 cifre per verificare.",
        login_phone_label: "Numero di telefono",
        login_phone_placeholder: "+355 68 123 4567",
        login_send_otp: "Invia codice",
        login_sending: "Invio…",
        login_otp_title: "Inserisci il codice",
        login_otp_subtitle: "Inviato a",
        login_verify: "Verifica",
        login_verifying: "Verifica…",
        login_resend: "Reinvia codice",
        login_change_number: "Cambia numero",
        login_dev_hint: "Modalità test: il tuo codice è",
        checkout_title: "Completa l'ordine",
        checkout_name_label: "Il tuo nome",
        checkout_address_label: "Indirizzo di consegna",
        checkout_address_placeholder: "Via, città, CAP",
        checkout_notes_label: "Note (opzionale)",
        checkout_total: "Totale",
        checkout_place: "Conferma ordine",
        checkout_placing: "Invio…",
        checkout_success_title: "Ordine confermato!",
        checkout_success_subtitle: "Lo riceverai entro 30 minuti. ID ordine:",
        checkout_continue: "Continua lo shopping",
        footer_made_in: "Fatto con ♥ in Albania",
        toast_added: "Aggiunto",
        toast_removed: "Rimosso",
        toast_otp_sent: "Codice inviato",
        toast_otp_error: "Codice errato. Riprova.",
        toast_otp_send_error: "Invio fallito. Riprova.",
        toast_login_success: "Bentornato!",
        toast_logged_out: "Disconnesso.",
        toast_order_error: "Ordine fallito. Riprova.",
        toast_login_required: "Accedi per continuare.",
    },
    el: {
        ui_language: "Γλώσσα",
        ui_currency: "Νόμισμα",
        search_placeholder: "Αναζήτηση προϊόντων…",
        promo_banner: "Δωρεάν αποστολή για παραγγελίες άνω των 2000 L · Πληρωμή κατά την παράδοση διαθέσιμη",
        section_hot_deals: "Καυτές προσφορές",
        section_all_products: "Όλα τα προϊόντα",
        section_no_products: "Δεν βρέθηκαν προϊόντα.",
        section_shop_by_category: "Αγορά ανά κατηγορία",
        filter_all: "Όλα",
        "cat.produce": "Φρούτα & Λαχανικά",
        "cat.dairy": "Γαλακτοκομικά & Αυγά",
        "cat.bakery": "Φούρνος",
        "cat.beverages": "Ποτά",
        "cat.meat": "Κρέας & Ψάρι",
        "cat.pantry": "Παντοπωλείο",
        product_off: "ΕΚΠΤΩΣΗ",
        product_add: "Προσθήκη",
        product_out_of_stock: "Εξαντλημένο",
        nav_login: "Σύνδεση",
        nav_logout: "Αποσύνδεση",
        cart_title: "Καλάθι σας",
        cart_empty: "Το καλάθι είναι άδειο",
        cart_empty_hint: "Προσθέστε προϊόντα για να συνεχίσετε.",
        cart_subtotal: "Υποσύνολο",
        cart_checkout: "Ολοκλήρωση",
        cart_continue: "Συνέχεια αγορών",
        login_title: "Σύνδεση με τηλέφωνο",
        login_subtitle: "Θα σας στείλουμε έναν εξαψήφιο κωδικό.",
        login_phone_label: "Αριθμός τηλεφώνου",
        login_phone_placeholder: "+355 68 123 4567",
        login_send_otp: "Αποστολή κωδικού",
        login_sending: "Αποστολή…",
        login_otp_title: "Εισάγετε τον κωδικό",
        login_otp_subtitle: "Στάλθηκε στο",
        login_verify: "Επαλήθευση",
        login_verifying: "Επαλήθευση…",
        login_resend: "Επαναποστολή",
        login_change_number: "Αλλαγή αριθμού",
        login_dev_hint: "Δοκιμαστική λειτουργία: ο κωδικός σας είναι",
        checkout_title: "Ολοκλήρωση παραγγελίας",
        checkout_name_label: "Το όνομά σας",
        checkout_address_label: "Διεύθυνση παράδοσης",
        checkout_address_placeholder: "Οδός, πόλη, ΤΚ",
        checkout_notes_label: "Σημειώσεις (προαιρετικά)",
        checkout_total: "Σύνολο",
        checkout_place: "Υποβολή παραγγελίας",
        checkout_placing: "Υποβολή…",
        checkout_success_title: "Η παραγγελία υποβλήθηκε!",
        checkout_success_subtitle: "Θα τη λάβετε εντός 30 λεπτών. Κωδικός παραγγελίας:",
        checkout_continue: "Συνέχεια αγορών",
        footer_made_in: "Φτιαγμένο με ♥ στην Αλβανία",
        toast_added: "Προστέθηκε",
        toast_removed: "Αφαιρέθηκε",
        toast_otp_sent: "Κωδικός στάλθηκε",
        toast_otp_error: "Λάθος κωδικός. Δοκιμάστε ξανά.",
        toast_otp_send_error: "Η αποστολή απέτυχε. Δοκιμάστε ξανά.",
        toast_login_success: "Καλώς ήρθατε!",
        toast_logged_out: "Αποσυνδεθήκατε.",
        toast_order_error: "Η παραγγελία απέτυχε. Δοκιμάστε ξανά.",
        toast_login_required: "Συνδεθείτε για να συνεχίσετε.",
    },
    fr: {
        ui_language: "Langue",
        ui_currency: "Devise",
        search_placeholder: "Rechercher des produits…",
        promo_banner: "Expédition gratuite pour les commandes de plus de 2000 L · Paiement à la livraison disponible",
        section_hot_deals: "Offres chaudes",
        section_all_products: "Tous les produits",
        section_no_products: "Aucun produit trouvé.",
        section_shop_by_category: "Acheter par catégorie",
        filter_all: "Tous",
        "cat.produce": "Fruits et Légumes",
        "cat.dairy": "Laitiers et Œufs",
        "cat.bakery": "Boulangerie",
        "cat.beverages": "Boissons",
        "cat.meat": "Viande et Poisson",
        "cat.pantry": "Épicerie",
        product_off: "RÉDUC",
        product_add: "Ajouter",
        product_out_of_stock: "Épuisé",
        nav_login: "Se connecter",
        nav_logout: "Déconnexion",
        cart_title: "Votre panier",
        cart_empty: "Votre panier est vide",
        cart_empty_hint: "Ajoutez des produits pour continuer.",
        cart_subtotal: "Sous-total",
        cart_checkout: "Commander",
        cart_continue: "Continuer les achats",
        login_title: "Connexion par téléphone",
        login_subtitle: "Nous vous enverrons un code à 6 chiffres pour vérifier.",
        login_phone_label: "Numéro de téléphone",
        login_phone_placeholder: "+355 68 123 4567",
        login_send_otp: "Envoyer le code",
        login_sending: "Envoi…",
        login_otp_title: "Entrez le code",
        login_otp_subtitle: "Envoyé à",
        login_verify: "Vérifier",
        login_verifying: "Vérification…",
        login_resend: "Renvoyer le code",
        login_change_number: "Changer de numéro",
        login_dev_hint: "Mode test : votre code est",
        checkout_title: "Finaliser la commande",
        checkout_name_label: "Votre nom",
        checkout_address_label: "Adresse de livraison",
        checkout_address_placeholder: "Rue, ville, code postal",
        checkout_notes_label: "Notes (optionnel)",
        checkout_total: "Total",
        checkout_place: "Passer commande",
        checkout_placing: "Envoi…",
        checkout_success_title: "Commande passée !",
        checkout_success_subtitle: "Vous la recevrez sous 30 minutes. ID de commande :",
        checkout_continue: "Continuer les achats",
        footer_made_in: "Fait avec ♥ en Albanie",
        toast_added: "Ajouté",
        toast_removed: "Supprimé",
        toast_otp_sent: "Code envoyé",
        toast_otp_error: "Code incorrect. Réessayez.",
        toast_otp_send_error: "Échec de l'envoi. Réessayez.",
        toast_login_success: "Bon retour !",
        toast_logged_out: "Déconnecté.",
        toast_order_error: "La commande a échoué. Réessayez.",
        toast_login_required: "Connectez-vous pour continuer.",
    },
    mk: {
        ui_language: "Јазик",
        ui_currency: "Валута",
        search_placeholder: "Барај производи…",
        promo_banner: "Бесплатна испорака за нарачки над 2000 L · Достапно плаќање при достава",
        section_hot_deals: "Жешки понуди",
        section_all_products: "Сите производи",
        section_no_products: "Не се пронајдени производи.",
        section_shop_by_category: "Купи по категорија",
        filter_all: "Сите",
        "cat.produce": "Овошје и Зеленчук",
        "cat.dairy": "Млечни и Јајца",
        "cat.bakery": "Пекара",
        "cat.beverages": "Пијалаци",
        "cat.meat": "Месо и Риба",
        "cat.pantry": "Намирници",
        product_off: "ПОПУСТ",
        product_add: "Додај",
        product_out_of_stock: "Распродадено",
        nav_login: "Најави се",
        nav_logout: "Одјави се",
        cart_title: "Твојата корпа",
        cart_empty: "Корпата е празна",
        cart_empty_hint: "Додај производи за да продолжиш.",
        cart_subtotal: "Меѓусума",
        cart_checkout: "Кон каса",
        cart_continue: "Продолжи со купување",
        login_title: "Најава со телефон",
        login_subtitle: "Ќе ти испратиме 6-цифрен код за верификација.",
        login_phone_label: "Телефонски број",
        login_phone_placeholder: "+355 68 123 4567",
        login_send_otp: "Испрати код",
        login_sending: "Испраќа…",
        login_otp_title: "Внеси го кодот",
        login_otp_subtitle: "Испратено до",
        login_verify: "Потврди",
        login_verifying: "Потврдува…",
        login_resend: "Испрати повторно",
        login_change_number: "Промени број",
        login_dev_hint: "Тест режим: твојот код е",
        checkout_title: "Заврши нарачка",
        checkout_name_label: "Твоето име",
        checkout_address_label: "Адреса за достава",
        checkout_address_placeholder: "Улица, град, поштенски број",
        checkout_notes_label: "Забелешки (опционално)",
        checkout_total: "Вкупно",
        checkout_place: "Нарачај",
        checkout_placing: "Нарачува…",
        checkout_success_title: "Нарачката е поднесена!",
        checkout_success_subtitle: "Ќе ја добиеш за 30 минути. ID на нарачка:",
        checkout_continue: "Продолжи со купување",
        footer_made_in: "Направено со ♥ во Албанија",
        toast_added: "Додадено",
        toast_removed: "Отстрането",
        toast_otp_sent: "Кодот е испратен",
        toast_otp_error: "Погрешен код. Обиди се повторно.",
        toast_otp_send_error: "Неуспешно праќање. Обиди се повторно.",
        toast_login_success: "Добредојде назад!",
        toast_logged_out: "Одјавен.",
        toast_order_error: "Нарачката е неуспешна. Обиди се повторно.",
        toast_login_required: "Најави се за да продолжиш.",
    },
};
